import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M940.253053,101.052632 C1098.40042,101.052632 1254.42568,143.696842 1391.55411,224.336842 L1391.55411,224.336842 L1309.39832,363.688421 C1197.22989,297.6 1069.49937,262.736842 940.253053,262.736842 C539.074105,262.736842 212.674105,589.136842 212.674105,990.315789 C212.674105,1391.49474 539.074105,1717.89474 940.253053,1717.89474 C1341.432,1717.89474 1667.832,1391.49474 1667.832,990.315789 C1667.832,861.069474 1632.86779,733.338947 1566.77937,621.069474 L1566.77937,621.069474 L1706.13095,539.014737 C1786.872,676.143158 1829.51621,832.269474 1829.51621,990.315789 C1829.51621,1480.62316 1430.56042,1879.57895 940.253053,1879.57895 C449.844632,1879.57895 50.9898947,1480.62316 50.9898947,990.315789 C50.9898947,499.907368 449.844632,101.052632 940.253053,101.052632 Z M940.263158,404.190316 L940.263158,565.874526 C706.225263,565.874526 515.842105,756.257684 515.842105,990.295579 C515.842105,1224.33347 706.225263,1414.71663 940.263158,1414.71663 C1174.2,1414.71663 1364.68421,1224.33347 1364.68421,990.295579 L1364.68421,990.295579 L1526.36842,990.295579 C1526.36842,1313.46189 1263.42947,1576.40084 940.263158,1576.40084 C617.096842,1576.40084 354.157895,1313.46189 354.157895,990.295579 C354.157895,667.129263 617.096842,404.190316 940.263158,404.190316 L940.263158,404.190316 Z M940.242947,707.328 L940.242947,869.012211 C873.346105,869.012211 818.979789,923.479579 818.979789,990.275368 C818.979789,1057.17221 873.346105,1111.53853 940.242947,1111.53853 C1007.13979,1111.53853 1061.50611,1057.17221 1061.50611,990.275368 L1061.50611,990.275368 L1223.19032,990.275368 C1223.19032,1146.30063 1096.26821,1273.22274 940.242947,1273.22274 C784.217684,1273.22274 657.295579,1146.30063 657.295579,990.275368 C657.295579,834.250105 784.217684,707.328 940.242947,707.328 L940.242947,707.328 Z M1677.06821,110.278737 L1820.05768,253.268211 L1393.71663,679.508211 L1580.25979,866.051368 L1064.48716,866.051368 L1064.48716,350.278737 L1250.82821,536.619789 L1677.06821,110.278737 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconOutcomesSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconOutcomesSolid, _Component);

  var _super = _createSuper(IconOutcomesSolid);

  function IconOutcomesSolid() {
    _classCallCheck(this, IconOutcomesSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconOutcomesSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconOutcomes",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconOutcomesSolid.displayName = "IconOutcomesSolid";
  return IconOutcomesSolid;
}(Component);

IconOutcomesSolid.glyphName = 'outcomes';
IconOutcomesSolid.variant = 'Solid';
IconOutcomesSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconOutcomesSolid;
export { IconOutcomesSolid };